<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout wrap justify-center align-center fill-height>
      <v-flex xs12 md10>
        <v-card elevation="18" style="overflow: hidden">
          <v-layout row>
            <v-flex
              v-if="!$vuetify.breakpoint.xsOnly"
              class="pa-0"
              xs12
              sm12
              md7
              lg8
            >
              <!-- :class="isVatan ? 'py-15' : ''" -->
              <DownloadApp  />
             
            </v-flex>

            <v-flex xs12 sm12 md5 lg4
             :align-self-center="isVatan ? true : false"
             :class="isVatan ? '' : 'mt-5'"
            >
              <v-card-text>
                <v-container>
                  <v-layout row wrap>
                    <v-card-title class="px-0 display-3 text--primary">
                      Giriş Yap
                    </v-card-title>
                    <v-card-text class="px-0 subheading">
                      Eğer hesabınız var ise buradan giriş yapabilirsiniz.
                    </v-card-text>
                    <v-form ref="form" lazy-validation @submit.prevent="login">
                      <v-layout
                        row
                        wrap
                        align-center
                        justify-center
                        class="my-5 mr-3"
                      >
                        <v-flex md12>
                          <v-text-field
                            v-model="user.username"
                            :rules="[$rules.empty('Kullanıcı Adı')]"
                            prepend-inner-icon="person"
                            required
                            label="Kullanıcı Adı"
                          >
                          </v-text-field>
                        </v-flex>
                        <v-flex md12>
                          <v-text-field
                            prepend-inner-icon="lock"
                            v-model="user.password"
                            :append-icon="
                              show ? 'visibility' : 'visibility_off'
                            "
                            :type="show ? 'text' : 'password'"
                            :rules="[$rules.empty('Şifre')]"
                            @click:append="show = !show"
                            required
                            label="Şifre"
                          >
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <div class="text-xs-right">
                        <v-btn rounded type="submit" color="amber darken-4" dark
                          >Giriş Yap
                        </v-btn>
                      </div>
                    </v-form>
                  </v-layout>
                  <v-layout row wrap justify-end align-end>
                    <div class="text-xs-center mt-2">
                      Hesabınız yok ise,
                      <a
                        class="v-breadcrumbs__item"
                        @click="directToRegister()"
                      >
                        buradan kayıt olabilirsiniz
                      </a>.

                      Eğer şifrenizi unuttuysanız buradan
                      <a
                        class="v-breadcrumbs__item"
                        @click="$router.push({ name: 'reset.password' })"
                        >sıfırlayabilirsiniz
                      </a>
                    </div>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
<!--     Android X butonu -->
<!--    <smart-banner></smart-banner>-->
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import SmartBanner from '../Components/SmartBanner.vue';
import DownloadApp from '../Components/DownloadApp.vue';

export default {
  name: 'Login',
  components: { SmartBanner, DownloadApp },
  data: () => ({
    show: false,
    user: {
      username: '',
      password: '',
    },
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    login(redirectUser = null, byRedirect = false) {
      if (byRedirect || this.$refs.form.validate()) {
        this.send({
          route: 'two/step/login/web',
          data: byRedirect ? redirectUser : this.user,
        }).then((res) => {
          if (res.data.data.numbers) {
            const selection = {
              numbers: res.data.data.numbers,
              username: this.user.username,
              password: this.user.password,
            };
            this.$store.commit("setSelection", selection);
            this.$router.push({ name: "selection" });
          } else {
            const twoFA = {
              resend: res.data.data.resend_key,
              hash: res.data.data.hash,
              state: true,
            };
            this.$store.commit("setTwoFA", twoFA);
            this.$router.push({ name: "2fa" });
          }
        });
      }
    },
    directToRegister() {
      // eslint-disable-next-line no-unused-expressions
      this.isVatan ? window.location.href = 'http://vatansms.com/register' : this.$router.push('register');
    },
  },
  created() {
    document.title = 'Toplu SMS Sistemi - GİRİŞ';
    if (this.$route.params.us) {
      this.login({ ...this.$route.params.us }, true);
    }
  },
  computed: {
    ratio() {
      let ratio = 0.0;

      switch (this.$vuetify.breakpoint) {
        case 'smOnly':
          ratio = 0.47;
          break;
        case 'mdAndUp':
          ratio = 11 / 9.3;
          break;
        case 'smAndUp' && 'lgAndDown':
          ratio = 1000;
          break;
        default:
          ratio = 0.84;
          break;
      }
      return ratio;
    },
    isVatan() {
      return window.location.href.includes('vatan');
    },
  },
};
</script>
